import React from 'react';

import st from './EventTopMatchInfo.module.sass';
import { MatchedCardInfo } from './MatchedCardInfo';
import { MatchedObjectInfo } from './MatchedObjectInfo';

function EventTopMatchInfo({
  cardId,
  topMatch,
}) {
  return (
    <div className={st.Root}>
      <MatchedCardInfo cardId={cardId} />

      {!!topMatch && (
        <React.Fragment>
          <div className={st.Divider} />
          <MatchedObjectInfo topMatch={topMatch} />
        </React.Fragment>
      )}
    </div>
  );
}

export { EventTopMatchInfo };
